import { fromEvent } from "rxjs";
import { store } from "@redux/store";
import { totalDeliveryValueActions } from "features/totalDeliveryValue";

const getDataset = (element) => element.dataset;

const firedCommunitiesResultsEvents = () => {
    const elements = document.querySelectorAll('[data-tdv-label="COMR"]');
    if (elements.length === 0) {
        return;
    }

    store.dispatch(totalDeliveryValueActions.fireTdvEvent({
        event: 'COMR',
        datasets: Array.from(elements).map(getDataset)
    }));
};

const firedHomesResultsEvents = () => {
    const elements = document.querySelectorAll('[data-tdv-label="HOMEHR"]');
    if (elements.length === 0) {
        return;
    }

    store.dispatch(totalDeliveryValueActions.fireTdvEvent({
        event: 'HOMEHR',
        datasets: Array.from(elements).map(getDataset)
    }));
};

const firedMasterPlanEvents = () => {
    const elements = document.querySelectorAll('[data-tdv-label="MPC_Result"]');
    if (elements.length === 0) {
        return;
    }

    store.dispatch(totalDeliveryValueActions.fireTdvEvent({
        event: 'MPC_Result',
        datasets: Array.from(elements).map(getDataset)
    }));
};

const trackEvents = () => {
    firedCommunitiesResultsEvents();
    firedHomesResultsEvents();
    firedMasterPlanEvents();
}

fromEvent(window, 'load').subscribe(trackEvents);

export default trackEvents;